export default __webpack_public_path__ + "static/media/waterproof-16.c05ed51c.svg";